<template>
  <div class="result">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getList"
      >
        <el-option
          v-for="item in teamlist"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案名称"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click="handleCheck(row.waId)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog class="detail-dialog" :visible.sync="show" width="40%" center>
      <table
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="10"
        align="center"
        class="table"
      >
        <tr>
          <td class="label" width="20%">集数</td>
          <td>第{{ form.episode }}集</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案名称</td>
          <td>{{ form.title }}</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案内容</td>
          <td><div v-html="form.content"></div></td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { resultList, info } from "@/api/projectPractice/copywriting";

export default {
  data() {
    return {
      teamId: null,
      teamlist: [],
      list: [],
      show: false,
      form: {},
    };
  },
  created() {
    this.getTeamList();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.teamlist.find((item) => item.teamId == this.teamId)
        : this.teamlist[0];
    },
  },
  methods: {
    // 团队列表
    getTeamList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamlist = res.data;
          if (this.teamlist) this.teamId = this.teamlist[0].teamId;

          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 成果列表
    getList() {
      this.$loading.show();
      resultList({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 文案详情
    handleCheck(waId) {
      this.$loading.show();
      info(waId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.form = res.data;
          this.show = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .info-row {
    margin-bottom: 10px;
    text-align: left;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: #409eff;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .detail-dialog {
    .label {
      text-align: center;
      font-weight: bold;
      background: #f5f5f5;
    }
  }
}
</style>